const importImages = path => {
  if (
    window.location.hostname === 'dev-ws2.jetsuite.com' ||
    window.location.hostname === 'localhost'
  ) {
    return 'https://d15vuanl9987q0.cloudfront.net/Dev' + path;
  } else {
    return 'https://d15vuanl9987q0.cloudfront.net/Production' + path;
  }
};
export default importImages;



// WEBPACK FOOTER //
// ./src/importImages.js